import {
  faPlus,
  faFileExcel,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "../../../global";

const InformationColumns = ({
  file = null,
  metadata,
  handleInformationColumnChange,
  removeInformationColumn,
  addInformationColumn,
  openExcelModal,
}) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold" style={{ color: colors.primary }}>
          Information Columns
        </h3>
        <span className="text-sm" style={{ color: colors.darkGray }}>
          {metadata.information_columns.length} column
          {metadata.information_columns.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Column List */}
      <div className="space-y-4">
        {metadata.information_columns.map((col, index) => (
          <div
            key={index}
            className="group relative bg-white rounded-xl border border-gray-200 p-4 hover:shadow-sm transition-all duration-200"
          >
            {/* Column Header */}
            <div className="flex items-center justify-between mb-3">
              <span
                className="text-sm font-medium"
                style={{ color: colors.darkGray }}
              >
                Column {index + 1}
              </span>
              <button
                onClick={() => removeInformationColumn(index)}
                className="opacity-0 group-hover:opacity-100 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-red-50"
                style={{ color: colors.error }}
                type="button"
                aria-label="Remove Column"
              >
                <FontAwesomeIcon icon={faX} />
              </button>
            </div>

            {/* Input Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {/* Name Input */}
              <div className="space-y-1">
                <label
                  className="text-xs font-medium"
                  style={{ color: colors.darkGray }}
                >
                  Name
                </label>
                <input
                  type="text"
                  value={col.name || ""}
                  onChange={(e) =>
                    handleInformationColumnChange(index, "name", e.target.value)
                  }
                  placeholder="Enter name"
                  className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200"
                  style={{
                    "--tw-ring-color": colors.primary + "40",
                    borderColor: col.name ? colors.primary + "40" : undefined,
                  }}
                />
              </div>

              {/* Column Input with Excel Button */}
              <div className="space-y-1">
                <label
                  className="text-xs font-medium"
                  style={{ color: colors.darkGray }}
                >
                  Column
                </label>
                <div className="flex">
                  <input
                    type="text"
                    value={col.column || ""}
                    onChange={(e) =>
                      handleInformationColumnChange(
                        index,
                        "column",
                        e.target.value
                      )
                    }
                    placeholder="Enter column"
                    className="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-l-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200"
                    style={{
                      "--tw-ring-color": colors.primary + "40",
                      borderColor: col.column
                        ? colors.primary + "40"
                        : undefined,
                    }}
                  />
                  {file &&
                    (metadata.file_name.endsWith(".csv") ||
                      metadata?.sheet_information?.sheet_name) && (
                      <button
                        onClick={() => openExcelModal(index)}
                        className="px-3 py-2 border border-l-0 border-gray-200 rounded-r-lg hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center"
                        type="button"
                        aria-label="Open Excel Sheet"
                        style={{ color: colors.primary }}
                      >
                        <FontAwesomeIcon icon={faFileExcel} />
                      </button>
                    )}
                </div>
              </div>

              {/* Hardcoded To Input */}
              <div className="space-y-1">
                <label
                  className="text-xs font-medium"
                  style={{ color: colors.darkGray }}
                >
                  Hardcoded To
                </label>
                <input
                  type="text"
                  value={col.hardcodedTo || ""}
                  onChange={(e) =>
                    handleInformationColumnChange(
                      index,
                      "hardcodedTo",
                      e.target.value
                    )
                  }
                  placeholder="Enter value"
                  className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200"
                  style={{
                    "--tw-ring-color": colors.primary + "40",
                    borderColor: col.hardcodedTo
                      ? colors.primary + "40"
                      : undefined,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Add Column Button */}
      <button
        onClick={addInformationColumn}
        className="w-full py-3 px-4 border-2 border-dashed border-gray-200 rounded-xl flex items-center justify-center gap-2 text-sm font-medium hover:border-gray-300 hover:bg-gray-50 transition-all duration-200 group"
        style={{ color: colors.primary }}
        type="button"
      >
        <FontAwesomeIcon
          icon={faPlus}
          size="16"
          className="group-hover:scale-110 transition-transform duration-200"
        />
        Add Information Column
      </button>

      {/* Empty State */}
      {metadata.information_columns.length === 0 && (
        <div className="text-center py-8">
          <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3">
            <FontAwesomeIcon
              icon={faFileExcel}
              style={{ color: colors.darkGray }}
              size={20}
            />
          </div>
          <p
            className="text-sm font-medium mb-1"
            style={{ color: colors.darkGray }}
          >
            No information columns yet
          </p>
          <p className="text-xs" style={{ color: colors.darkGray + "80" }}>
            Add your first column to get started
          </p>
        </div>
      )}
    </div>
  );
};

export default InformationColumns;
